import React, { FC, useReducer } from 'react';
import {
    IRepresentationInvitationDto,
    RepresentationInvitationDto,
} from '../../../../Services/ClientProxy/clientProxy';

export type UpdateRepresentationAction = {
    type: 'updateRepresentation';
    payload: Partial<IRepresentationInvitationDto>;
};
export type ResetRepresentationAction = {
    type: 'Reset';
};

export type RepresentationInvitationAction =
    | UpdateRepresentationAction
    | ResetRepresentationAction;

export interface RepresentationType {
    state: IRepresentationInvitationDto;
    dispatch: React.Dispatch<RepresentationInvitationAction>;
}

export type RepresentationReducer = (
    state: IRepresentationInvitationDto,
    action: RepresentationInvitationAction
) => IRepresentationInvitationDto;

function getIntialState() {
    return new RepresentationInvitationDto({
        email: undefined,
        dateDeactivate: undefined,
        namePrimaryLang: '',
        nameSecondaryLang: '',
        nationalID: '',
        surnamePrimaryLang: '',
        surnameSecondaryLang: '',
        dateActivate: new Date(Date.now()),
        isAdministrator: true,
        allBranches:true,
        hasCustomRole: false,
        claims: undefined,
        restrictedBranch: undefined
    });
}

interface Props {
    children: JSX.Element;
}

export const RepresentationContext =
    React.createContext<RepresentationType>({
        state: new RepresentationInvitationDto(),
        dispatch: () => {
            /* */
        },
    });
    
export const RepresentationProvider: FC<Props> = (props: Props) => {
    const { children } = props;
    const [state, dispatch] = useReducer<RepresentationReducer>(
        (
            currentState: IRepresentationInvitationDto,
            action: RepresentationInvitationAction
        ) => {
            switch (action.type) {
                case 'updateRepresentation':
                    return { ...currentState, ...action.payload };
                case 'Reset':
                    return getIntialState();
                default:
            }
            return currentState;
        },
        getIntialState()
    );

    return (
        <RepresentationContext.Provider
            value={{ state, dispatch }}
        >
            {children}
        </RepresentationContext.Provider>
    );
};
